import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import {AuthGuardService}from'./services/auth-guard.service';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import * as firebase from 'firebase';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { IonicSelectableModule } from 'ionic-selectable';
import { ChartsModule } from 'ng2-charts';
import 'chartjs-plugin-zoom';
import {ModalDatasetPageModule}from'./modal-dataset/modal-dataset.module'
import {ModalUploadPageModule}from'./modal-upload/modal-upload.module'

import { CalendarModule } from 'ion2-calendar';

import {Paso1pagePageModule} from './paso1page/paso1page.module'
import {Paso2pagePageModule} from './paso2page/paso2page.module'
import {Paso3pagePageModule} from './paso3page/paso3page.module'
import {Paso4pagePageModule} from './paso4page/paso4page.module'
import {Paso5pagePageModule} from './paso5page/paso5page.module'
import {Paso6pagePageModule} from './paso6page/paso6page.module'

import {TimelineComponent} from './timeline/timeline.component'



var config = {
  apiKey: "AIzaSyCR9JzAvg7blumth9rpCcxgckHSDr6M7MA",
  authDomain: "gt-ptw.firebaseapp.com",
  databaseURL: "https://gt-ptw.firebaseio.com",
  projectId: "gt-ptw",
  storageBucket: "gt-ptw.appspot.com",
  messagingSenderId: "526164954130",
  appId: "1:526164954130:web:598790b2a4b378fb1c5ccb"
};

firebase.initializeApp(config);

@NgModule({
  declarations: [AppComponent],
  entryComponents: [],
  imports: [BrowserModule, 
    IonicModule.forRoot(), 
    AppRoutingModule,
    IonicSelectableModule,
    ChartsModule,
    ModalDatasetPageModule,
    ModalUploadPageModule,
    CalendarModule,

    Paso1pagePageModule,
    Paso2pagePageModule,
    Paso3pagePageModule,
    Paso4pagePageModule,
    Paso5pagePageModule,
    Paso6pagePageModule
  
  ],
  providers: [
    StatusBar,
    SplashScreen,
    TimelineComponent,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
